import {
    DeviceOverview,
    FilterByModel,
    Sensor,
    SensorInfo,
    SensorModel,
} from "../models/sensor.model";
import { GridService, IGridService } from "../shared/grid/grid.service";

import { EditSensorDialogData } from "../modals/editSensorDialog/editSensorDialog.component";
import { EndpointService } from "./endpoint.service";
import { GridModel } from "../shared/grid/grid.model";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastService } from "./toast.service";
import { catchError } from "rxjs/operators";
import { of } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class SensorService
    extends GridService<SensorModel>
    implements IGridService<SensorModel>
{
    constructor(
        http: HttpClient,
        private toastService: ToastService,
    ) {
        super("Sensor", http);
    }

    get(
        filter: string,
        orderBy: string,
        sort: string,
        page: number,
        pageSize: number,
        filterBy: string,
    ) {
        return this.http.get<GridModel<SensorModel>>(
            this.getApiUrl("Sensor/GetSensors"),
            {
                params: this.createParamsWithFilterBy(
                    filter,
                    orderBy,
                    sort,
                    page,
                    pageSize,
                    filterBy,
                ),
            },
        );
    }

    getLowBatterySensorCount(batteryLevel: number) {
        return this.http
            .get<number>(
                this.getApiUrl(
                    `Sensor/GetLowBatterySensorCount?batteryLevel=${batteryLevel}`,
                ),
            )
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading low battery sensor count",
                        true,
                    );
                    return of();
                }),
            );
    }

    updateSensor(payload: EditSensorDialogData) {
        return this.http.post(this.getApiUrl("Sensor/UpdateSensor"), payload);
    }

    getSensorLookupList() {
        return this.http
            .get<Sensor[]>(this.getApiUrl("Sensor/GetSensorLookupList"))
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading sensors",
                        true,
                    );
                    return of([]);
                }),
            );
    }

    getSensorType(sensorId: string) {
        return this.http
            .get<
                string[]
            >(this.getApiUrl(`Sensor/GetSensorType?sensorId=${sensorId}`))
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading Sensor Type",
                        true,
                    );
                    return of([]);
                }),
            );
    }

    getDeviceSummaryData() {
        return this.http
            .get<DeviceOverview>(this.getApiUrl("Sensor/GetDeviceOverview"))
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading Device Summary",
                        true,
                    );
                    return of();
                }),
            );
    }

    getSensorInfo(sensorId: string) {
        return this.http
            .get<SensorInfo>(
                this.getApiUrl(`Sensor/GetSensorInfo?sensorId=${sensorId}`),
            )
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading Sensor Info",
                        true,
                    );
                    return of();
                }),
            );
    }

    getOrCreateSensorByAirNowSiteId(siteId: string, organizationLevelId: string) {
        return this.http.get<Sensor>(
            this.getApiUrl(
                `Sensor/GetOrCreateSensorByAirNowSiteId?siteId=${encodeURIComponent(siteId)}&organizationLevelId=${encodeURIComponent(organizationLevelId)}`,
            ),
        );
    }
}
